<template>
  <div class="inputgrid" 
    :class="{'warning': errors.length > 0, 'en': $i18n.locale == 'en'}">
    <span>{{ label }}</span>
    <ComboSearch 
      class="cmbox"
      v-if="type == 'select'"
      :caretend="true"
      :bordercolor="getBorderColor()"
      ref="comboBox"
      :defaultmsg="$t('selectoptions')" 
      :options="options" 
      droppaneClass="notop"
      dropClass="nopaddingtop"
      :model-value="modelValue"
      :disabled="options.length == 0"
      @update:modelValue="onInput" /> 
    <FormDateInput
      :label="label"  
      :model-value="modelValue"
      @update:modelValue="onInput"
      :isMonth="type == 'datem'"
      v-if="type == 'date' || type == 'datem'" />  
  </div>
</template>

<script>
import { ComboSearch } from "umaui";
import FormDateInput from '@/components/formDateInput.vue';

export default {
  name: 'FormElement',
  props:["label","index","options","modelValue","trysubmit","updateValue","errors","type"],
  emits:["update:modelValue"],
  components:{
    ComboSearch,
    FormDateInput
  },
  methods: {
    onInput(value) {
      this.$emit('update:modelValue', value);
      if (this.updateValue) {
        this.updateValue(value);
      }
    },
    getBorderColor(){
      if(this.errors.length > 0){
        return 'red'
      }
    },
  }
}
</script>

<style>
@media screen and (max-width: 1024px) {
  .nopaddingtop{
    padding-top: 0;
    padding-bottom: 0;
  }
  /*.dropdown-pane .drop.nopaddingtop,.nopaddingtop{
    padding-top: 0;
    padding-bottom: 0;
  }*/
}

@media only screen and (max-width: 767px) {
  .dropdown-pane.notop#grauDropDown {
    top: 40px;
  }
  .dropdown-pane .drop.nopaddingtop,.nopaddingtop{
    padding-top: 0;
  }

  .cmbox input {
    padding-top: 5px;
    padding-bottom: 5px;
  }

  .dropdownbtn.end i {
    padding-top: 6px;
  }
}
</style>

<style scoped>
.inputgrid {
  display: grid;
  grid-template-columns: 80px 1fr;
  grid-gap: 5px;
  margin-bottom: 20px;
}

.inputgrid.en{
  grid-template-columns: 110px 1fr;
}

span {
  font-family: "Montserrat";
  display: flex;
  align-items: center;
  font-size: 16px;
}

@media only screen and (max-width: 767px) {
  .inputgrid{
    grid-template-columns: 1fr;
  }

  .inputgrid span {
    font-size: 13px;
    margin-left: 16px;
  }

  .inputgrid {
    margin-bottom: 12px;
  }

  .dropdownbtn.end .value {
    padding-left: 18px;
  }

}

</style>